import { styled } from "styled-components";

export const HiddenInput = styled.input`
  display: none;
`;

export const VideoUploadContainer = styled.div<{ $isUploading: boolean }>`
  cursor: pointer;
  position: relative;
  pointer-events: ${({ $isUploading }) => ($isUploading ? "none" : "auto")};
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-m"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-secondary"].value};

  &:hover {
    & {
      border-color: ${({ theme }) =>
        theme.Color.border["ui-border-emphasize-brand"].value};
      background: ${({ theme }) =>
        theme.Color.background.brand.subtlest["default-hover"].value};
    }
    & > div {
      & > button {
        background: ${({ theme }) =>
          theme.Color.background.brand.default.value};
      }
      & > label:nth-child(2) {
        color: ${({ theme }) =>
          theme.Color.text["text-emphasize-brand-bolder"].value};
      }
    }
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
  padding: 47px ${({ theme }) => theme.spacing["spacing-4"].value}rem 47px;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px dashed
    ${({ theme }) => theme.Color.border["ui-border-emphasize-brand"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary-emphasize-hover"].value};

  & > button {
    background: ${({ theme }) =>
      theme.Color.background.brand.subtle.default.value};
  }
`;

export const ButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
